var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col items-center justify-center min-h-36 md:min-h-96 md:w-5/6 mx-auto md:pl-9 p-5"},[_c('ProductDetail',{attrs:{"product":_vm.getProduct(_vm.id)},on:{"add-product-to-cart":function($event){return _vm.$emit('add-product-to-cart', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }